import SideBar from '@/components/side_bar/SideBar.vue';
import AnalyticDash from '@/components/analytic_dash/AnalyticDash.vue';

export default {
  components: {
    SideBar,
    AnalyticDash
  }
};
